<template>
  <span>
    <v-card>
      <v-card-title class='headline font-weight-regular oem-color'>
        Software Version
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-sub-title>
                Firmware version
              </v-list-tile-sub-title>
              <v-list-tile-title>
                {{ version }}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-card-actions>
              <v-btn class='ml-1 oem-text-color' @click='startUpdate()'>
                Update
              </v-btn>
            </v-card-actions>
          </v-list-tile>
        </v-list>
      </v-card-text>
    </v-card>
    <v-dialog v-model='updateDialog' persistent max-width='500px'>
      <v-card>
        <v-card-text>
          <span class='oem-text-color'>
          <v-progress-circular
               v-if='showProgress'
              :value='updateValue'
              :size='64'
              :width='7'
              class='mr-2 oem-text-color'
            >
              <div v-if='updateValue !== null'>
                {{ updateValue }}%
              </div>
            </v-progress-circular>
            {{ updateText }}
          </span>
          <div v-if='showFilePicker'>
            <v-text-field prepend-icon='attach_file' single-line
              label='Choose a file'
              @click.native='onFocus' readonly
              ref='fileTextField'>
            </v-text-field>
            <input type='file' accept='.swu' ref='fileInput' @change="handleFiles">
          </div>
          <!-- <input v-if='showFilePicker'
          type='file' ref='fileInput' accept='.swu' @change='handleFiles()'> -->
        </v-card-text>
        <v-card-actions>
          <v-btn v-if='showCloseButton'
            flat class='oem-text-color' @click='close()'>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model='rebootUpdateDialog' persistent max-width='500px'>
        <v-card>
        <v-card-title class='headline font-weight-regular oem-color'>
          Rebooting
        </v-card-title>
        <v-card-text>
          {{ rebootProgressMessage }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import axios from 'axios';
import ajax from '../ajax';
import * as auth from '../auth';

export default {
  name: 'SoftwareUpdate',
  props: {
    version: String,
  },
  data() {
    return {
      socket: null,
      updateValue: 0,
      updateDialog: false,
      updateText: '',
      showProgress: false,
      showFilePicker: true,
      showCloseButton: true,
      cancelSource: null,

      rebootProgressMessage1: 'Waiting for system to restart.',
      rebootProgressMessage2: 'Waiting for system to come back online.',
      rebootProgressMessage: 'Rebooting....',
      rebootUpdateDialog: false,
      startDateTime: null,
    };
  },
  methods: {
    setupWebsocket() {
      this.socket.onmessage = function progress(event) {
        const data = JSON.parse(event.data);
        if (data.type === 'step') {
          this.updateValue = 50 + Math.floor(data.percent / 2);
          this.updateText = 'Updating firmware. Please wait.';
          this.showFilePicker = false;
          this.showCloseButton = false;
          this.showProgress = true;
          this.$store.state.updatingFirmware = true;
        }
        if (data.type === 'status') {
          if (data.status === 'FAILURE') {
            this.updateText = 'Failed to install firmware. Please try again (error #1).';
            this.$store.addEventLog('Firmware update failed');
            this.cancelSource.cancel();
            this.showFilePicker = true;
            this.showCloseButton = true;
            this.$store.state.updatingFirmware = false;
          } else if (data.status === 'SUCCESS') {
            this.showProgress = false;
            this.updateText = 'Succesfully installed new firmware. The device will now reboot...';
            this.$store.addEventLog('Firmware update succeeded');
            this.showCloseButton = true;
            this.updateDialog = false; // We won't show the update dialg, because we will show the new restart dialog
            this.reboot();
          }
        }
      }.bind(this);
    },
    startUpdate() {
      this.updateDialog = true;
    },
    onFocus() {
      this.$refs.fileInput.click();
    },
    handleFiles() {
      let server = `${window.location.hostname}:8181`;

      // Use different URL for development
      if (window.location.hostname === 'localhost'
          && window.location.port === '8090') {
        // server = '192.168.0.39:8181';
        server = '10.10.5.2:8181';
      }

      const formData = new FormData();
      const fileInput = this.$refs.fileInput.files;
      formData.append('file', fileInput.item(0));
      this.cancelSource = axios.CancelToken.source();
      this.socket = new WebSocket(`ws://${server}/ws`);
      const this2 = this;
      setTimeout(() => { this2.setupWebsocket(); }, 4000); // Setup web-socket, but delay for 4 second because the upload needs to start first


      const config = {
        url: `http://${server}/upload`,
        method: 'post',
        data: formData,
        timeout: 300000,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          this.updateValue = Math.floor((progressEvent.loaded * 50) / progressEvent.total);
          this.$store.state.updatingFirmware = true;
        },
        cancelToken: this.cancelSource.token,
      };
      this.updateText = 'Uploading firmware. Please wait.';
      this.$store.addEventLog('Started firmware update');
      this.showProgress = true;
      this.showFilePicker = false;
      this.showCloseButton = false;
      this.updateValue = null;
      this.$refs.fileInput.value = null;
      this.doUpload(config);
    },
    doUpload(config) {
      if (config.tryCount === undefined) {
        config.tryCount = 1;
      } else {
        config.tryCount += 1;
      }
      // const this2 = this;
      axios(config)
        .then(() => {
          this.updateValue = 50;
          this.$store.state.updatingFirmware = true;
        }).catch((e) => {
          console.log(new Error().stack); // eslint-disable-line no-console
          if (axios.isCancel(e)) {
            this.updateText = 'Failed to install firmware (canceled). Please try again';
          } else {
            // if (config.tryCount === 1) {
            //  setTimeout(function() { this2.doUpload(config); }, 1000);
            // } else {
            this.updateText = 'Failed to upload firmware to device. Please reboot the device and try to upload the firmware again.';
            this.$store.addEventLog(`Firmware update failed. ${e}`);
            this.showProgress = false;
            this.showCloseButton = true;
            this.showFilePicker = true;
            // }
          }
          this.showProgress = false;
          this.$store.state.updatingFirmware = false;
        });
    },
    close() {
      this.updateDialog = false;
      this.showProgress = false;
      this.showFilePicker = true;
      this.updateText = '';
    },
    reboot() {
      ajax.get('config/static')
        .then((response) => {
          this.startDateTime = response.data.startDateTime;
          ajax.put('system/reboot', { })
            .then(() => {
              this.rebootUpdateDialog = true;
              this.rebootProgressMessage = `${this.rebootProgressMessage1}...`;
              this.$store.addEventLog('Reboot');
              setTimeout(() => { this.checkIfSystemIsShutDown(0); }, 1000);
            })
            .catch((e) => {
              console.log(e); // eslint-disable-line no-console
              this.$store.addEventLog(`Failed to perform a reboot. ${e}`);
            });
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          this.$store.addEventLog(`Failed to perform a reboot. ${e}`);
        });
    },
    checkIfSystemIsShutDown(count) {
      // console.log(`Wait untill offline ${count}`);
      ajax.get('config/static')
        .then((response) => {
          // Still online (or very quickly rebooted)
          if (this.startDateTime !== response.data.startDateTime) { // If very quickly rebooted
            // Back online
            this.startDateTime = null;
            this.systemRebooted();
          } else {
            if (this.rebootProgressMessage.endsWith('....')) {
              this.rebootProgressMessage = this.rebootProgressMessage1;
            } else {
              this.rebootProgressMessage = `${this.rebootProgressMessage}.`;
            }
            setTimeout(() => { this.checkIfSystemIsShutDown(count + 1); }, 1000);
          }
        })
        .catch(() => {
          setTimeout(() => { this.checkIfSystemIsUp(0); }, 1000);
        });
    },
    checkIfSystemIsUp(count) {
      // console.log(`Wait untill online ${count}`);
      ajax.get('config/static')
        .then((response) => {
          // Back online
          if (this.startDateTime !== response.data.startDateTime) {
            this.systemRebooted();
          } else { // Apparently not really rebooted, because the startDateTime is still the same
            setTimeout(() => { this.checkIfSystemIsShutDown(0); }, 1000);
          }
        })
        .catch(() => {
          // Not yet back online
          if (this.rebootProgressMessage.endsWith('....')) {
            this.rebootProgressMessage = this.rebootProgressMessage2;
          } else {
            this.rebootProgressMessage = `${this.rebootProgressMessage}.`;
          }
          setTimeout(() => { this.checkIfSystemIsUp(count + 1); }, 1000);
        });
    },
    systemRebooted() {
      auth.clearAccessToken();
      window.location.reload();
    },
  },
};
</script>

<style scoped>
    input[type=file] {
        display: none;
    }
</style>
